class GlossarySupport {
  constructor(selector) {
    this.selector = selector;
    this.glossaryWords = {};

    let glossaryScript = document.querySelector('script[data-glossary-support]');
    let glossaryData = JSON.parse(glossaryScript.textContent);
    this.glossaryWords = glossaryData.glossaryWords;
  }

  replaceWordsWithGlossaryTerms() {
    const elements = document.querySelectorAll(this.selector);

    elements.forEach(element => {
      const originalContent = element.innerHTML;
      let newContent = originalContent;

      Object.keys(this.glossaryWords).forEach(word => {
        const regex = new RegExp(`\\b${word}\\b`, 'gi');
        newContent = newContent.replace(regex, `<span class="glossary-term" data-tippy-glossary="${this.glossaryWords[word]}">${word}</span>`);
      });

      element.innerHTML = newContent;
    });
  }

  initializeGlossaryTippy() {
    document.querySelectorAll('[data-tippy-glossary]:not(.tippy-initialized)').forEach(div => {
      const instance = tippy(div, {
        theme: 'tippy-glossary',
        content: div.dataset.tippyGlossary
      });
      // console.log(instance)
      div.classList.add('tippy-initialized');
    });
  }

  initialize() {
    this.replaceWordsWithGlossaryTerms();
    this.initializeGlossaryTippy();
  }
}

const donorNetworkGlossary = new GlossarySupport('[data-glossary]');
donorNetworkGlossary.initialize();